import { bootstrapApplication } from '@angular/platform-browser';
import { mergeApplicationConfig } from '@angular/core';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { captureBootstrapError, provideSentry, sentryHttpInterceptor } from './app/telemetry/sentry';

const browserConfig = mergeApplicationConfig(appConfig, {
  providers: [...provideSentry(), provideHttpClient(withXhr(), withInterceptors([sentryHttpInterceptor]))],
});

bootstrapApplication(App, browserConfig).catch(captureBootstrapError);
